/* FJBC wishlist.

   E0 (Eli, 2026-09-06): keep the heart, build a page. E1 (2026-09-10): theme-side, no app, saved
   in the browser (THEME-PLAN.md section 6). The list is an array of product handles under one
   localStorage key. There are no accounts and nothing is sent to the store, so the list is private
   to this browser and is lost when the visitor clears their storage. The wishlist page says so.

   Public API, window.FJBCWishlist:
     list()            -> array of handles, oldest first
     has(handle)       -> boolean
     add(handle)       -> array
     remove(handle)    -> array
     toggle(handle)    -> array
     clear()           -> array

   Every change writes storage, re-syncs every [data-wishlist-toggle] button on the page and
   dispatches `fjbc:wishlist` on the document with { detail: { handles: [...] } }. The event also
   fires once when this file finishes loading, so a page that renders from the list can listen for
   it without caring whether it ran before or after this script.

   The file guards against running twice: the wishlist page and the wishlist button each ask for
   it, so a page can carry the tag more than once. */

(function () {
  if (window.FJBCWishlist) return;

  var KEY = 'fjbc-wishlist';

  function read() {
    var raw;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (error) {
      /* Private mode, or storage disabled. The site keeps working without a wishlist. */
      return [];
    }
    if (!raw) return [];

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (error) {
      return [];
    }
    if (!Array.isArray(parsed)) return [];

    var handles = [];
    for (var i = 0; i < parsed.length; i += 1) {
      var handle = typeof parsed[i] === 'string' ? parsed[i].trim() : '';
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
    }
    return handles;
  }

  function write(handles) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (error) {
      /* Storage is full or unavailable. The in-page state below still updates. */
    }
    return handles;
  }

  function syncButtons(handles) {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      var handle = button.getAttribute('data-wishlist-toggle');
      var saved = handles.indexOf(handle) !== -1;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');

      /* The button ships `disabled` so that it is never a dead control with scripting off
         (snippets/wishlist-button.liquid, 2026-09-18 D1). This is the pass that proves scripting
         works, so it is where the button becomes usable. */
      if (button.disabled) button.disabled = false;

      var label = button.getAttribute(saved ? 'data-label-on' : 'data-label-off');
      if (label) {
        var text = button.querySelector('[data-wishlist-label]') || button;
        if (text.textContent !== label) text.textContent = label;
      }
    }
  }

  function announce(handles) {
    syncButtons(handles);
    document.dispatchEvent(new CustomEvent('fjbc:wishlist', { detail: { handles: handles.slice() } }));
    return handles;
  }

  var api = {
    list: function () {
      return read();
    },

    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },

    add: function (handle) {
      if (!handle) return read();
      var handles = read();
      if (handles.indexOf(handle) === -1) handles.push(handle);
      return announce(write(handles));
    },

    remove: function (handle) {
      var handles = read();
      var at = handles.indexOf(handle);
      if (at !== -1) handles.splice(at, 1);
      return announce(write(handles));
    },

    toggle: function (handle) {
      return api.has(handle) ? api.remove(handle) : api.add(handle);
    },

    clear: function () {
      return announce(write([]));
    }
  };

  window.FJBCWishlist = api;

  /* Delegated, so a button added later (a theme-editor re-render, a page built by script) works
     without re-binding. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('[data-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    api.toggle(button.getAttribute('data-wishlist-toggle'));
  });

  /* A section re-rendered in the theme editor brings new buttons, which have never been synced and
     are still `disabled`. Shopify fires this on the document after it swaps the markup in. */
  document.addEventListener('shopify:section:load', function () {
    announce(read());
  });

  /* Another tab changed the list. */
  window.addEventListener('storage', function (event) {
    if (event.key && event.key !== KEY) return;
    announce(read());
  });

  function start() {
    announce(read());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
